module.exports = ".box-center{\n    max-width: 75%;\n    margin: auto;\n}"